export default "__VITE_ASSET__CP4rAuR9__"